export const FETCH_USER = 'FETCH_USER'
export const FETCH_USER_SUCCESS = 'FETCH_USER_SUCCESS'
export const FETCH_USER_ERROR = 'FETCH_USER_ERROR'
export const LOGOUT = 'LOGOUT'
export const FETCH_LOCATION = 'FETCH_LOCATION'
export const FETCH_BUSINESSES = 'FETCH_BUSINESSES'
export const FETCH_FAVORITES = 'FETCH_FAVORITES'
export const UPDATE_FAVORITE = 'UPDATE_FAVORITE'
export const CLEANUP_BUSINESSES = 'CLEANUP_BUSINESSES'
